import convertTimestampToShamsi from '@/common/utils/convertTimestampToShamsi';
import { VisitInformationTypeParams } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVisitInformation/getVisitInformationQuer.type';
import { VisitOtherInformationResponseType } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVisitOtherDamagedInformation/getVisitOtherDamagedInformationQuer.type';
import { getVisitOtherInformationQueryFunction } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getVisitOtherDamagedInformation/getVisitOtherDamagedInformationQueryFunction';
import { queryOptions } from '@tanstack/react-query';

const getOtherVisitInformation = (params: VisitInformationTypeParams) =>
  queryOptions({
    queryKey: ['get_vehicle_damage_amount', params],
    queryFn: () => getVisitOtherInformationQueryFunction(params),
    select: (data: VisitOtherInformationResponseType) => {
      return {
        ...data,
        visit_date: data?.visit_date
          ? convertTimestampToShamsi(Number(data?.visit_date))
          : new Date().toLocaleDateString('fa-IR'),
        visit_site: {
          label: data?.visit_site?.fa_const,
          value: data?.visit_site?.const,
        },
        visit_location: data?.visit_location,
      };
    },
  });

export default getOtherVisitInformation;
